import { render, staticRenderFns } from "./Contacto.vue?vue&type=template&id=e69427b4&lang=pug"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"
import style0 from "./Contacto.vue?vue&type=style&index=0&id=e69427b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports